import type { ValueFormatterParams } from "ag-grid-community";

import { InvoiceStatusDisplay } from "~/modules/accounting/invoice-status";
import { OrderStatusDisplay } from "~/modules/orders/order-status";

const ORDER_STATUS_VALUES = ["VOID", "DRAFT", "CONFIRMED", "SHIPPED", "DELIVERED", "COMPLETED"] as const;
const INVOICE_STATUS_VALUES = ["DRAFT", "POSTED", "PARTIALLY_PAID", "PAID", "VOID"] as const;

export const StatusCellRenderer = (params: ValueFormatterParams<string>) => {
  try {
    if (!params?.value) {
      return null;
    }

    const statusValue = params.value;

    if ((ORDER_STATUS_VALUES as readonly string[]).includes(statusValue)) {
      return <OrderStatusDisplay status={statusValue} />;
    }

    if ((INVOICE_STATUS_VALUES as readonly string[]).includes(statusValue)) {
      return <InvoiceStatusDisplay status={statusValue} />;
    }

    // Fallback for unknown statuses - don't crash
    return <span>{statusValue}</span>;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      // biome-ignore-start lint/suspicious/noConsole: carried over from the ESLint suppression
      console.error("StatusCellRenderer error:", error, { params });
      // biome-ignore-end lint/suspicious/noConsole: carried over from the ESLint suppression
    }
    return <span>Error rendering status</span>;
  }
};
